import axios from "axios";
import React, { useState } from "react";
import { Modal, Form, Input, Typography, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Error, Success } from "../../../commons/Messages/Messages";

import { useTranslation } from "react-i18next";
const { Text } = Typography;

const UpdateBoard = ({ updateParent, data, onOpen }) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = e => {
    e?.stopPropagation();
    form.setFieldsValue({ title: data?.title });
    onOpen?.();
    setIsModalOpen(true);
  };

  const handleCancel = e => {
    e?.stopPropagation();
    setIsModalOpen(false);
  };

  const onFinish = async values => {
    try {
      setLoading(true);
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/ticketBoards/update/${data?._id}`,
        {
          title: values.title
        },
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        }
      );

      if (res.status === 200 || res.status === 304) {
        Success(t(res.data.successMessage));
        updateParent();
        handleCancel();
      } else {
        Error(res.data.errorMessage);
      }
    } catch (err) {
      Error(err.response?.data?.errorMessage || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="text" block icon={<EditOutlined />} onClick={showModal}>
        {t("Rename Board")}
      </Button>

      <Modal
        title={
          <div className="tkt-modal-title">
            <span>{t("Rename Board")}</span>
            <span className="tkt-modal-subtitle">{t("Enter a new name for the workspace.")}</span>
          </div>
        }
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={() => form.submit()}
        confirmLoading={loading}
        okText={t("Save")}
        cancelText={t("Cancel")}
        centered
        width={440}
        rootClassName="tkt-modal"
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="title"
            label={<Text strong>{t("Board Name")}</Text>}
            rules={[{ required: true, message: t("Required") }]}
          >
            <Input size="large" placeholder={t("E.g. Engineering")} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default UpdateBoard;
